import { AvailableTerms, ProfileTerm } from './AvailableTerms';
import { LatestPaymentsTable } from './LatestPaymentsTable';
import { useGetSellerCustomerSpendingLimit } from '../../../../api/lending/lapiHooks';
import { hasCompanyName } from '../../customerName';
import { CustomerRow } from '../../CustomersV2.types';
import { isSpendableLimit } from '../../spendableLimit';

// The trigger gate guarantees limit_amount is set for `complete` rows, so an
// empty limits response still yields one honest term from the row itself —
// rather than V1's invented limit that timed out "now".
const fallbackTerms = (row: CustomerRow): ProfileTerm[] => {
  if (row.limit_amount === null) return [];

  return [
    {
      availableAmount: row.limit_amount,
      durationInMonths: row.limit_duration ?? 3,
      isValid: isSpendableLimit(row),
      timeout: row.limit_timeout,
    },
  ];
};

export const DecisionProfile = ({ row }: { row: CustomerRow }) => {
  const { spendingLimit, loadingSpendingLimit } =
    useGetSellerCustomerSpendingLimit({ buyerStateKey: row.buyer_state_key });

  const fetchedTerms: ProfileTerm[] = (spendingLimit ?? []).map((limit) => ({
    availableAmount: limit.available_amount,
    durationInMonths: limit.duration_in_months,
    isValid: limit.is_valid,
    timeout: limit.timeout,
  }));

  const terms = fetchedTerms.length > 0 ? fetchedTerms : fallbackTerms(row);

  return (
    <div className="flex flex-col gap-xl">
      <AvailableTerms
        terms={terms}
        loading={loadingSpendingLimit}
        email={row.email}
      />
      <LatestPaymentsTable
        buyerStateKey={row.buyer_state_key}
        buyerName={hasCompanyName(row) ? row.company_name : ''}
      />
    </div>
  );
};
